import { Reveal } from "./Reveal";

const CHAPTERS = [
  { n: "01", t: "Cooked fresh, never frozen", d: "Every order is prepared the same day by our in-house chefs — no reheated shortcuts." },
  { n: "02", t: "Honest, per-plate pricing", d: "What you see is what you pay. Transparent packages, no hidden service traps." },
  { n: "03", t: "On-time, every time", d: "Kanpur-wide delivery and setup, timed to your event — down to the minute." },
];

export function Manifesto() {
  return (
    <section className="px-5 py-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <span className="text-xs tracking-[0.25em] uppercase font-semibold text-primary">Why The Quisine</span>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="border-t border-primary/20 pt-5">
                <span className="font-serif text-5xl text-accent">{c.n}</span>
                <h3 className="font-serif text-2xl text-primary tracking-tight mt-3">{c.t}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
